import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col, Container, Row } from 'reactstrap'

const Features = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    window.requestAnimationFrame(() => scroll())
  })

  const scroll = () => {
    if (location.hash) {
      const refName = location.hash.replace(/^#/, '')
      if (refName) {
        const el = document.getElementById(refName)
        if (el) {
          window.scrollTo({ left: 0, top: el.offsetTop - 20, behavior: 'smooth' })
          setTimeout(() => {
            if ((el.offsetTop - 20).toFixed() > 0 && window.scrollY === 0) {
              window.scrollTo({ left: 0, top: el.offsetTop - 20, behavior: 'smooth' })
            }
          }, 100)
        }
      }
    }
  }

  const scrollIfNecessary = (tag) => {
    const el = document.getElementById(tag)
    const refName = location.hash.replace(/^#/, '')
    if (el && ((refName !== tag) || ((el.offsetTop - 20).toFixed() > window.scrollY.toFixed() || (el.offsetTop - 20).toFixed() < (window.scrollY + window.visualViewport.height).toFixed()))) {
      if (tag !== refName) {
        navigate(`/features#${tag}`)
      } else {
        window.scrollTo({ left: 0, top: el.offsetTop - 20, behavior: 'smooth' })
      }
    }
  }

  const renderLink = (link, term) => {
    if (!term) term = link
    const tag = link.replace(/^[\W+]/, '')
    return (<span
      className="text-primary text-center mouse-pointer rounded-5px padding-5"
      onClick={() => scrollIfNecessary(tag)}
    >
      {term}
    </span>)
  }

  return (
    <div className="container proxima-nova">
      <div className="border1 rounded05 left-sidebar margin-right">
        <h5>Decide What Matters</h5>
        <h6>{renderLink('priorities', 'Priorities')}</h6>
        <h6>{renderLink('strategies', 'Strategies')}</h6>
        <h6>{renderLink('goals', 'Goals')}</h6>
        <h5>Do it</h5>
        <h6>{renderLink('journal', 'Journal')}</h6>
        <h5>Learn</h5>
        <h6>{renderLink('comments', 'Comments')}</h6>
        <h6>{renderLink('mentions', '@Mentions')}</h6>
        <h6>{renderLink('follow', 'Follow')}</h6>
        <h6>{renderLink('hashtags', '#Hashtags')}</h6>
        <h6>{renderLink('reports', 'Reports')}</h6>
        <h6>{renderLink('reviews', 'Reviews')}</h6>
        <h5>Leverage</h5>
        <h6>{renderLink('integrations', 'Integrations')}</h6>
        <h6>{renderLink('api', 'Open API')}</h6>
        <h6>{renderLink('webhooks', 'Webhooks')}</h6>
      </div>

      <div className="main-content" style={{ fontSize: 18 }}>
        <Container id="main-content">
          <Row className="margin-top-top border05 rounded1 padding2">
            <Col xs="12">
              <h1>Decide What Matters...</h1>
            </Col>
          </Row>
          <Row className="margin-top-top border05 rounded1 padding2" id="priorities">
            <Col xs="12">
              <h2>Priorities</h2>
              <p>
                How do you spell success?
              </p>
              <p>
                Business Priorities are a few core values that ultimately define success for your business. These form
                the umbrella under which all other business activities find their purpose.
              </p>
              <p>
                You may define success in terms of the &#34;bottom line&#34;, but it may make more sense to make the priority
                Customer Loyalty, for example. If you succeed at Customer Loyalty, then that will result in the &#34;bottom
                line&#34; you&#39;re looking for.
              </p>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="strategies">
            <Col xs="12">
              <h2>Strategies</h2>
              <p>
                Given one to three business priorities, each team lead sets up strategies focused on each priority.
              </p>
              <p>
                For example, a customer care team can impact customer loyalty through responsiveness and courtesy,
                through timely and relevant solutions, and even through proactive solutions. However, a development team
                can impact customer loyalty through software quality, user-friendly design, and features that meet
                customer needs.
              </p>
              <p>
                Once each team has a set of one or two strategies for each priority, these form a matrix of strategies
                that keep all teams focused on the business priorities.
              </p>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="goals">
            <Col xs="12">
              <h2>Goals</h2>
              <p>
                Given a set of team strategies for each priority, each team member can begin setting personal goals to
                work toward those strategies.
              </p>
              <p>
                This will keep team members focused on activities that will ultimately meet the business priorities.
              </p>
            </Col>
          </Row>
          <Row className="margin-top-top border05 rounded1 padding2">
            <Col xs="12">
              <h1>Do It...</h1>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="journal">
            <Col xs="12">
              <h2>Journal</h2>
              <p>
                With a hierarchy of business priorities, team strategies, and individual goals in place, each team
                member works to accomplish their goals, and logs journal entries for the progress they&#39;ve made.
              </p>
              <p>
                As work is done and journal entries are made toward each goal, all team members can now see the progress
                being made. Further, notes of risks and issues can be seen by the entire business. These journal entries
                provide a record of work done for each goal which is aligned with a strategy and a priority. This log
                will provide valuable reporting
                (see {renderLink('reports', 'Reports')} and {renderLink('reviews', 'Reviews')}).
              </p>
            </Col>
          </Row>
          <Row className="margin-top-top border05 rounded1 padding2">
            <Col xs="12">
              <h2>Learn...</h2>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="comments">
            <Col xs="12">
              <h2>Comments</h2>
              <p>
                As journal entries are made, other team members may have solutions to issues noted, and so they can
                comment on journal entries.
              </p>
              <p>
                In addition, comment threads with nested replies provide an effective way for the team to collaborate.
              </p>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="mentions">
            <Col xs="12">
              <h2>@Mentions</h2>
              <p>
                Journal entries as well as comments can include @mentions which will notify other team members.
              </p>
              <p>
                Mentions can be configured by team members to notify by text message, by email, or in-app. In addition,
                mentions will show up on the dashboard for easy access.
              </p>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="follow">
            <Col xs="12">
              <h2>Follow</h2>
              <p>
                Anyone in the business can Follow activity toward a priority, a strategy, or a goal, allowing them to be
                notified of all journal entries logged toward the followed entity.
              </p>
              <p>
                In addition, anyone can follow specific #hashtags, allowing their activity stream to show any journal
                entry with that #hashtag.
              </p>
              <p>
                Follows can be configured by team members to notify by text message, by email, or in-app. In addition,
                follows will show up as an activity stream on the dashboard for easy access.
              </p>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="hashtags">
            <Col xs="12">
              <h2>#Hashtags</h2>
              <p>
                Journal entries can be tagged using #hashtags which will facilitate {renderLink('follow', 'Follow')} as
                well as {renderLink('reports', 'Reports')}.
              </p>
              <p>
                #Hashtags can be used for noting important updates, like <b>#completed</b> or <b>#risk</b>. Or they can
                be used to denote the project being worked like <b>#mercury</b>.
              </p>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="reports">
            <Col xs="12">
              <h2>Reports</h2>
              <p>
                Once your teams are journaling progress toward their goals, now comes the fun part! Reporting!
              </p>
              <p>
                The first thing you&#39;ll want to do is filter by the date of the journal entries.
              </p>
              <p>
                Then, you can limit the report to one or more priorities, or one or more strategies, or you can select
                one or more goals. By default, you&#39;ll see activities for all priorities.
              </p>
              <p>
                In addition, you can limit to one or more team member or one or more teams. By default, you&#39;ll see
                activities logged by all members.
              </p>
              <p>
                As with the {renderLink('follow', 'Follow')} feature, you can also limit a report to one or
                more {renderLink('hashtags', '#hashtags')}.
              </p>
              <p>
                You have the ability to group the logged progress by priority, by strategy, by goal, by team, or by team
                member. And you can even group by more than one of these entities.
              </p>
              <p>
                Once you&#39;ve set up the report you want, you can save it, and optionally add the report to your
                dashboard. Once saved, you can also set up periodic exports, where the report will be emailed to you at
                specific times, for example, at 8:30AM on Monday morning in preparation for a 9AM staff meeting.
              </p>
              <p>
                This feature gives you the ability to automate weekly or monthly reports. In fact, you can use this as a
                way to automate a SCRUM-like daily or weekly virtual stand-up meeting. Or you could use this as a
                starting point for your stand-up meetings, saving the time listening to each team member say,
                &#34;Yesterday, I did X, Y, and Z.&#34;
              </p>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="reviews">
            <Col xs="12">
              <h2>Performance Reviews</h2>
              <p>
                Most companies have annual performance reviews, but most of us have trouble remembering all the great
                work that&#39;s been done in the last year.
              </p>
              <p>
                A specialized report for all the work done by an individual, organized by the goals, strategies, and
                priorities, provides a useful tool to show how much or how little was contributed.
              </p>
              <p>
                More important than a raw listing of journal entries is the opportunity to adjust plans and expectations
                for the future, all based on actual data rather than intuition.
              </p>
            </Col>
          </Row>
          <Row className="margin-top-top border05 rounded1 padding2">
            <Col xs="12">
              <h1>Leverage...</h1>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="integrations">
            <Col xs="12">
              <h2>Integrations</h2>
              <p>
                Several integrations with popular tools are planned beginning with:
              </p>
              <ul>
                <li>Slack</li>
                <li>Zapier</li>
              </ul>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="api">
            <Col xs="12">
              <h2>Open API</h2>
              <p>
                An Open API (REST API) is planned, and will provide ability to list, read, and write the following data
                entities (subject to user role permissions):
              </p>
              <ul>
                <li>priorities</li>
                <li>strategies</li>
                <li>goals</li>
                <li>journal entries</li>
                <li>comments</li>
                <li>mentions</li>
                <li>follows</li>
                <li>hashtags</li>
              </ul>
            </Col>
          </Row>
          <Row className="margin-top border05 rounded1 padding2" id="webhooks">
            <Col xs="12">
              <h2>Webhooks</h2>
              <p>
                Webhooks are planned for create, update, delete of the following entities:
              </p>
              <ul>
                <li>account user</li>
                <li>priorities</li>
                <li>strategies</li>
                <li>goals</li>
                <li>journal entries</li>
                <li>comments</li>
                <li>mentions</li>
                <li>follows</li>
                <li>hashtags</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Features
